// extracted by mini-css-extract-plugin
module.exports = {"Outer":"Pie_Outer__15tD8","innerText":"Pie_innerText__3YEMg","number":"Pie_number__2uUgV","afterDecimal":"Pie_afterDecimal__qHyMb","totalDiv":"Pie_totalDiv__1L1CN"};